// import { url } from '@/config';

const baseUrl = process.env.BASE_URL;

const request = window.axios;
export const getList = (params) => request({
  url: '/api/sophain-visual/visual/list',
  method: 'get',
  params: params
});



export const copyObj = (id) => request({
  url: '/api/sophain-visual/visual/copy',
  method: 'post',
  params: {
    id: id
  }
});

export const getCategory = (params) => request({
  url: '/api/sophain-visual/category/list',
  method: 'get',
  params: params
});

export const getObj = (id) => request({
  url: '/api/sophain-visual/visual/detail',
  method: 'get',
  params: {
    id
  }
});
export const uploadImg = (file) => request({
  url: '/api/sophain-visual/visual/put-file',
  method: 'post',
  data: 'file=' + file,
  headers: { "Content-Type": "multipart/form-data" }
});

export const addObj = (data) => request({
  url: '/api/sophain-visual/visual/save',
  method: 'post',
  data: {
    visual: {
      password: data.password,
      category: data.category,
      status: data.status,
      title: data.title,
    },
    config: {
      detail: JSON.stringify({
        name: data.title,
        width: data.width,
        height: data.height,
        scale: 1,
        backgroundImage: `${baseUrl}img/bg/bg1.png`,
        url: '',
        mark: {},
        gradeShow: false,
        gradeLen: 30,
      }),
      component: '[]'
    },
  }
});

export const updateComponent = (data) => request({
  url: '/api/sophain-visual/visual/update',
  method: 'post',
  data: data
});

export const updateObj = (data) => request({
  url: '/api/sophain-visual/visual/update',
  method: 'post',
  data: {
    "visual": {
      "id": data.id,
      "password": data.password,
      "category": data.category,
      "status": data.status,
      "title": data.title,
    }
  }
});

export const delObj = (id) => request({
  url: '/api/sophain-visual/visual/remove',
  method: 'post',
  params: {
    ids: id
  }
});